import Label from "../../atoms/label/Label";
import styles from "./productDetailsPromotions.module.scss";
import PropTypes from "prop-types";
import LabelText from "../../atoms/label/LabelText";
import { Link } from "../../atoms/DependencyHelper";
import labels from "../../../config/labels";
import LinkRoute from "../../atoms/linkRoute/LinkRoute";
import config from "../../../config";
import { isExternalUrl } from "../../../utils/helperServices"
import types from "../../../config/types";

const ProductDetailsPromotions = ({
	className,
	variant,
	tagText,
	description,
	isPromotionTagLink,
	promotionTag,
	uniquePromoId,
	descriptionTime,
	promotionLink,
	flag,
	labelColor,
}) => {
	const generateVariantStyle = () => {
		return variant ? styles["promotion--" + variant] : "";
	};
	const isPreOrder = tagText == types.TYPE_PREORDER ? true : false;

	// For Filter with on the appropriate promotion on product list page
	const createPromotionFilter = (value, label) => {
		return value + ":" + label;
	};
	const env = config.env;
	const urlPrefix = config.envConfigs[env].shoppingUrlPrefix;
	return tagText || description || promotionLink ? (
		<div className={className}>
			<LabelText uniqueLabelId={uniquePromoId}>Promotions:</LabelText>
			<div
				className={`${styles.promotion} mt-s mb-l ${generateVariantStyle()}`}
			>
				{tagText && (
					<Label className={`${styles["promotion__tag"]}`} text={isPreOrder ? labels.lbl_pre_order_online_exclusive_tag : tagText} labelColor={labelColor} />
				)}
				{isPromotionTagLink || promotionLink ? (
					<>
					{promotionLink!==null && (	
					<div>
						<LinkRoute
							href={promotionLink ? 
								(isExternalUrl(promotionLink) ? `${promotionLink}` : `${urlPrefix}/${promotionLink}`)
							 	: `${urlPrefix}/deals`}
							as={promotionLink ? null : `${urlPrefix}/deals?promotions=${createPromotionFilter(
								promotionTag,
								variant
							)}`}
							text={isPreOrder ? "" : labels.lbl_promotion_tag_link}
							className={`${isPreOrder ? "" : styles["promotion__description__link"]}`}

						></LinkRoute>
						<a>
						&nbsp;{isPreOrder ? "" : labels.lbl_promotion_tag_text}
						</a>
						</div>
					)}
					</>
				) : (
					!flag ?
					<span className={styles["promotion__description"]}>
						{description}<span className={styles["description_font"]}>{descriptionTime}</span>
					</span> :""
				)}
			</div>
			<hr className="d-none d-lg-block product-details-bottom-hr"
			 />
		</div>
	) : (
		""
	);
};

ProductDetailsPromotions.defaultProps = {
	className: "",
	variant: "",
	promotionTag: "",
};
ProductDetailsPromotions.propTypes = {
	className: PropTypes.string,
	variant: PropTypes.string,
	tagText: PropTypes.string,
	description: PropTypes.string,
	descriptionTime:  PropTypes.string
};

export default ProductDetailsPromotions;
